import CompanyData from "../CompanyData";
import Button from "../../assets/components/Button";

const bookNow = (
  <Button variant="secondary" onClick={() => alert("Primary button clicked!")}>
    Book Now
  </Button>
);
const comp = CompanyData[0];

const HeroSliderText = [
  {
    title: `Professional tattoo studio, ${comp.location}`,
    text: `Professional tattooing, ${comp.location}. Everything you should know about tattooing before you get tattooed. Ask us. Come to us for a consultation and inquire about tattoo prices.`,
    button: bookNow,
  },
  {
    title: `Thinking about a tattoo?`,
    text: `Send us your idea and schedule your appointment now!`,
    button: bookNow,
  },
  {
    title: `${comp.name} Tattoo Studio`,
    text: `It brings together artists covering all styles of tattooing. We can paint your idea on the part of the body that you choose, and we can also help you with the choice of tattoo. If you are not sure where you want to get tattooed, with our experience - we will find the ideal place and type of tattoo for you! Although we cover all styles of tattooing, there are those for which we are particularly famous, and for which clients from home and abroad come to us.`,
    button: bookNow,
  },
];

export default HeroSliderText;
